import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import b1 from "../../assets/images/homeBanner1.png";
import b2 from "../../assets/images/homeBanner2.png";
import b3 from "../../assets/images/homeBanner3.png";
import b4 from "../../assets/images/b4.png";

import todaySpecial from "../../assets/images/Today’s Special.png";
import freshPicks from "../../assets/images/Fresh Picks.png";
import snackBreak from "../../assets/images/Snack Break.png";
import menuBuilt from "../../assets/images/Hungry For More_.png";
import { useNavigate } from "react-router-dom";

const HomeBannerMobile = () => {
  const navigate = useNavigate();

  const banners = [
    {
      title: "Small Smoked BBQ Pulled Pork",
      subtitle: todaySpecial,
      desc: "Slow-smoked, tender pulled pork packed with rich BBQ flavor and served fresh off the grill. A little portion with big-time taste.",
      btn: "ORDER TODAY'S SPECIAL",
      url: "/menu",
      img: b1,
    },
    {
      title: "A Menu Built for Every Craving",
      subtitle: menuBuilt,
      desc: "Our kitchen doesn’t stop at one signature dish. Discover a curated selection of authentic flavors and timeless favorites designed for every palate.",
      btn: "VIEW MENU",
      url: "/menu",
      img: b4,
      // width: "1440",
      // titleWidth: "398",
    },
    {
      title: "All Your Favorites in One Place",
      subtitle: freshPicks,
      desc: "From pantry staples to fresh produce, snacks, and more — everything you need, all in one stop.",
      btn: "VIEW MENU",
      url: "/store/vendors",
      img: b2,
    },
    {
      title: "Snack Break Favorites",
      subtitle: snackBreak,
      desc: "Quick bites, bold flavors, and satisfying snacks to fuel your day anytime.",
      btn: "VIEW MENU",
      url: "/store/vendors",
      img: b3,
    },
  ];

  const responsive = {
    desktop: { breakpoint: { max: 1555, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 1 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
  };

  return (
    <section id="home-banner-mobile" className="home-banner-mobile">
      <Carousel
        responsive={responsive}
        autoPlay
        infinite
        arrows={false}
        showDots
        autoPlaySpeed={4000}
        containerClass="carousel-container"
        dotListClass="mobile-carousel-dots"
        itemClass="carousel-item-mobile"
      >
        {banners.map((banner, index) => (
          <div key={index} className="mobile-banner-slide">
            <img src={banner.img} alt={banner.title} className="mobile-banner-image" />
            <div className="mobile-banner-overlay">
              <img src={banner.subtitle} alt="subtitle" className="mobile-subtitle" />
              <h2 className="mobile-title">{banner.title}</h2>
              <p className={`description ${banner.img === b2 ? "des-gray" : "des-white"}`}>{banner.desc}</p>
              <button
                className={`cta-button ${banner.img === b1 || banner.img === b4 ? "cta-btn-red" : banner.img === b2 ? "cta-btn-blue" : "cta-btn-transparent"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(banner.url);
                }}
              >
                {banner.btn}
              </button>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default HomeBannerMobile;
